import type { ReactNode } from 'react';
import React from 'react';

type NameProps = {
  children?: ReactNode;
  value?: string;
};
function Name({ children, value }: NameProps) {
  return (
    <h3 className="Offer-name" data-testid="name">
      {children || value}
    </h3>
  );
}

Name.displayName = 'Name';

export { Name };
